import { getJobProgress, isJobFinished, isJobSucceeded } from '../helpers';
import { YesNoFlag } from '../../types';

export const lastUpdatedSelector = state => state.jim.lastUpdated;

export const isFetchingJobs = state => state.jim.fetching;

export const jobsSelector = state => state.jim.jobs;

export const jobByIdSelector = jobId => state =>
  state.jim.jobs
    .find(job => job.jobId === jobId);

export const jobsByIdSetSelector = jobsSet => state => jobsSet.map(jobSet =>
  state.jim.jobs.find(job => job.jobId === jobSet.jobId)
);

export const lastJobOfTypeSelectorFactory = jobType => state =>
  state.jim.jobs
    .find(job => job.jobType === jobType);

export const jobsOfTypeSelectorFactory = jobType => state =>
  state.jim.jobs
    .filter(job => job.jobType === jobType);

export const isLastJobOfTypeFinishedSelectorFactory = jobType => {
  const jobsOfTypeSelector = lastJobOfTypeSelectorFactory(jobType);
  return state => {
    const job = jobsOfTypeSelector(state);

    if (job) {
      return isJobFinished(job);
    }
    return true;
  };
};

export const isLastJobOfTypeSucceededSelectorFactory = jobType => {
  const jobsOfTypeSelector = lastJobOfTypeSelectorFactory(jobType);
  return state => {
    const job = jobsOfTypeSelector(state);

    if (job) {
      return isJobSucceeded(job);
    }
    return false;
  };
};

export const isLastJobOfTypeInProgressSelectorFactory = jobType => {
  const isLastJobOfTypeFinishedSelector = isLastJobOfTypeFinishedSelectorFactory(jobType);

  return state => !isLastJobOfTypeFinishedSelector(state);
};

export const progressOfLastJobOfTypeSelectorFactory = jobType => {
  const jobsOfTypeSelector = lastJobOfTypeSelectorFactory(jobType);
  return state => {
    const job = jobsOfTypeSelector(state);
    return getJobProgress(job);
  };
};

export const idOfLastJobOfTypeSelectorFactory = jobType => {
  const jobsOfTypeSelector = lastJobOfTypeSelectorFactory(jobType);
  return state => {
    const job = jobsOfTypeSelector(state);
    if (job) {
      return job.jobId;
    }
    return null;
  };
};

export const isAnyJobInProgressSelector = state =>
  state.jim.jobs.some(job => !isJobFinished(job));

export const unreadJobNotificationsSelector = state =>
  state.jim.jobs.filter(job => isJobFinished(job) && job.notificationSeenFlag === YesNoFlag.N);

export const isAddingJobOfTypeSelectorFactory = jobType =>
  state => state.jim.jobTypesBeingAdded.has(jobType);
